module.exports = __webpack_public_path__ + "img/whatsapp.b48347eb.png";